import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import useOrgId from 'hooks/useOrgId.js';

const useWebBroadcasterCredentials = (appId, options = {}) => {
  const orgId = useOrgId();
  const uid = useSelector((state) => state.sessionState.authUser?.uid);
  const { enabled = true, ...rest } = options;
  const isQueryEnabled = !!(enabled && !!appId && !!orgId && !!uid && orgId !== 'no-team');

  return useQuery({
    queryKey: ['o', orgId, appId, 'broadcaster', 'credentials'],
    queryFn: async () => {
      const res = await fetch('https://cdn.bambuser.net/broadcastTickets', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/vnd.bambuser.cdn.v1+json',
          'X-Bambuser-ClientPlatform': 'web',
          'X-Bambuser-ClientVersion': 'web',
          'X-Bambuser-ApplicationId': appId,
        },
        body: JSON.stringify({
          httpUpgradeCapable: true,
          tlsCapable: true,
        }),
      });
      const result = await res.json();
      const broadcastHost = result?.movinoServer?.host;
      const username = result?.ingestChannel?.name;
      const password = result?.ingestChannel?.token;
      if (!broadcastHost || !username || !password) throw new Error('Failed to get broadcast credentials');
      return {
        serverUrl: `wss://${broadcastHost}/webrtc`,
        username,
        password,
      };
    },
    enabled: isQueryEnabled,
    ...rest,
  });
};

export default useWebBroadcasterCredentials;
